<div class="container error-container">
  <div class="row justify-content-center text-center pt-4">
    <div class="col-lg-4 col-md-8 col-sm-12 col-xs-12">
      <div class="error-content">
        <div class="error-wrap">
          <div class="logo">
            <img class="mt-5 mb-5" src="assets/images/azay-logo.png" />
          </div>
          <div class="text-danger error-message" [innerHTML]="errorMessage | translate"></div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="error-footer text-center">
  <hr />
  &copy; Allianz Ayudhaya (Thailand).
</div>
